"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeService = void 0;

var lodash_1 = require("lodash");

var Repository_1 = __importDefault(require("./Repository"));

var entities_1 = require("../../entities");

var MeService =
/** @class */
function () {
  function MeService(baseUrl, authorization) {
    this.repository = new Repository_1.default(baseUrl, authorization);
  }
  /**
   * @deprecated
   * @description for get cartId - please, use MeService.getUser()
   */


  MeService.prototype.getCartId = function () {
    return this.repository.getCartId().then(function (data) {
      return Promise.resolve(lodash_1.get(data, "me.user.cart.id", 0));
    });
  };

  MeService.prototype.getUser = function () {
    return this.repository.getUser().then(function (data) {
      return Promise.resolve(new entities_1.UserEntity(lodash_1.get(data, "me.user")));
    });
  };

  MeService.prototype.updateProfile = function (phone, firstName, lastName, dob, email, residence) {
    return this.repository.updateProfile(phone, firstName, lastName, dob, email, residence).then(function (data) {
      return Promise.resolve(new entities_1.UserEntity(lodash_1.get(data, "updateMe.user")));
    });
  };

  MeService.prototype.saveUserDocument = function (fileId, fileUrl, type) {
    return this.repository.saveUserDocument(fileId, fileUrl, type);
  };

  return MeService;
}();

exports.MeService = MeService;